<div class="userform">
  <div class="logo pointer" routerLink="/">
    <img
      *ngIf="routing.theme !== 'light'"
      src="assets/logo/{{ logo }}_default.svg"
      alt="yukkalab"
    />
    <img
      *ngIf="routing.theme === 'light'"
      src="assets/logo/{{ logo }}_default_light.svg"
      alt="yukkalab"
    />
  </div>

  <div class="message">
    <div *ngIf="messages[message]">{{ messages[message] }}</div>
    <div *ngIf="message == 'error404'">
      <div class="error404">ERROR 404</div>
    </div>
    <div *ngIf="message == 'nosubscription'">
      <div class="error404">SUBSCRIPTION REQUIRED</div>
      <div>A Yukka subscription is required to access this feature.</div>
    </div>
    <div *ngIf="message == 'errorMessage' && errorMessage">
      <div>{{ errorMessage }}</div>
    </div>
    <div *ngIf="message == 'autherror'">
      <div>
        This service is currently not available<br />We apologize for any
        inconvenience.
      </div>
    </div>
  </div>

  <div class="disclaimer">
    <span class="link" routerLink="../../login">login page</span>
  </div>
</div>
